import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-invoice-share-by-email',
  templateUrl: './invoice-share-by-email.component.html',
  styleUrls: ['./invoice-share-by-email.component.scss']
})
export class InvoiceShareByEmailComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  email:any
  apisub: Subscription
  constructor(private _modelRef:MatDialog,private activemodal: MatDialogRef<InvoiceShareByEmailComponent>,@Inject(MAT_DIALOG_DATA) public parentdata:any, private loaderservice: LoaderServiceService, private apiservice: ApiService) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_SEND_INVOICE_EMAIL){
        if(resdata.result){
          this.loaderservice.showLoader = false
          this.activemodal.close(resdata.result)
        }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_SEND_INTERNATIONAL_INVOICE_EMAIL){
        if(resdata.result){
          this.loaderservice.showLoader = false
          this.activemodal.close(resdata.result)
        }
      }
    })



   }

  ngOnInit(): void {
    console.log(this.parentdata);
    
    this.email = sessionStorage.getItem('mefrp') && sessionStorage.getItem('mefrp') != 'null' ? sessionStorage.getItem('mefrp') : null
  }
  shareViaEmail(){
      // Remove leading and trailing commas and spaces
            this.email = this.email.replace(/^[,\s]+|[,\s]+$/g, '');
    
            // Ensure that spaces after commas are removed
            this.email = this.email.replace(/\s*,\s*/g, ',');
            
            let emailContents = this.email.split(',')
    
            if(emailContents.length>1){
              this._modelRef.open(CustomConfirmDialogComponent,{
                width: '500px',
                data : {
                  title : 'Alert',
                  message : "You can send maximum 1 invitation E-mail at once. Send the extra ones in another try.",
                  okbtn : 'Ok',
                  cancelbtn : 'Cancel',
                  type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
                },
                disableClose : true
              });
            }
            else{
              let obj = {
                "recipient": this.email, 
                "invoice_hash": this.parentdata.invoiceHash, 
                "entity_hash": this.parentdata.entityHash
              }
          
              if(this.isEntityForeign == '0'){
                this.loaderservice.showLoader = true
                this.apiservice.sendInvoiceViaEmail(obj)
          
              }
              else if(this.isEntityForeign == '1'){
                this.loaderservice.showLoader = true
                this.apiservice.sendInternationalInvoiceViaEmail(obj)
              }
              
            }

  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

  checkdis(){

      if (!this.email || this.email.trim() === '' || this.email == undefined) {
        return true;
      }
      // Clean and split the email addresses
      let cleanedEmails = this.email
        .replace(/^[,\s]+|[,\s]+$/g, '')
        .replace(/\s*,\s*/g, ',')
        .split(',');
  
      // Check for invalid emails
      let hasInvalidEmail = cleanedEmails.some((email:any) => !this.isValidEmail(email));
  
      // Disable if any invalid email exists
      return hasInvalidEmail;
    
    return true; // Default disable
  }
  
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
